import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { useTranslation } from "react-i18next";

import { api } from "../../convex/_generated/api";
import { PaneHeader } from "@/components/settings/frame";
import { ClientsSection } from "@/components/workspaces/clients-section";

// Studio: who the clients of this workspace are and what each may do.
export const Route = createFileRoute("/settings/clients")({
  component: ClientsPage,
});

function ClientsPage() {
  const { t } = useTranslation("settings");
  const workspace = useQuery(api.workspaces.getMyWorkspace);
  const plan = useQuery(api.billing.getMyPlan);
  if (workspace === undefined || plan === undefined) return null;
  // Only the team of a Studio workspace has clients to manage, and in a design studio only roles that may.
  if (workspace?.role !== "team" || !workspace.can.clients || plan?.plan !== "studio") return <Navigate to="/settings" replace />;
  return (
    <div>
      <PaneHeader title={t("nav.clients")} description={t("clients.description")} />
      <div className="border-t border-line-strong pt-6">
        <ClientsSection />
      </div>
    </div>
  );
}
